var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.6445 59.4992V34.6992C35.6445 32.4992 37.4445 30.6992 39.6445 30.6992C41.8445 30.6992 43.6445 32.4992 43.6445 34.6992V59.4992M35.6445 68.6992V56.8992C35.6445 53.5992 32.9445 50.8992 29.6445 50.8992C28.5445 50.8992 27.6445 51.7992 27.6445 52.8992V73.6992C27.6445 83.6992 32.6445 87.6992 32.6445 87.6992M32.6445 87.6992L8.64453 99.6992M32.6445 87.6992C50.6445 78.6992 46.6445 101.699 32.6445 87.6992ZM51.6445 59.4992V34.6992C51.6445 32.4992 53.4445 30.6992 55.6445 30.6992C57.8445 30.6992 59.6445 32.4992 59.6445 34.6992V59.4992M43.6445 56.4992V31.6992C43.6445 29.4992 45.4445 27.6992 47.6445 27.6992C49.8445 27.6992 51.6445 29.4992 51.6445 31.6992V56.4992M59.6445 98.6992L87.6445 112.699M33.6445 112.699L51.6445 103.699C61.6445 98.6992 67.6445 89.6992 67.6445 77.5992V38.6992C67.6445 36.4992 69.4445 34.6992 71.6445 34.6992C73.8445 34.6992 75.6445 36.4992 75.6445 38.6992V76.7992C75.6445 79.7992 77.3445 82.5992 80.0445 83.9992L111.645 99.7992M68.6445 20.6992L76.6445 12.6992M52.6445 20.6992L44.6445 12.6992M60.6445 19.6992V8.69922",
    stroke: "#2EC4B2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hand.c83630fc.svg";
export { ForwardRef as ReactComponent };